import { https } from 'shared/utils/https';
import type {
  ICreateShortcutRequestDTO,
  ICreateShortcutResponseDTO,
  IShortcutListRequestDTO,
  IShortcutListResponseDTO,
  IShortcutPriceGroupsResponseDTO,
  IUpdateShortcutRequestDTO,
} from './shortcuts.dto';

const baseURL = `/v1/shortcuts`;

export const shortcutsData = {
  getShortcutList: async (params: IShortcutListRequestDTO): Promise<IShortcutListResponseDTO> => {
    const response = await https.get<IShortcutListResponseDTO>(baseURL, { params });

    const { data } = response;
    return data;
  },

  createShortcut: async (body: ICreateShortcutRequestDTO): Promise<ICreateShortcutResponseDTO> => {
    const response = await https.post<ICreateShortcutResponseDTO>(baseURL, body);

    const { data } = response;
    return data;
  },

  updateShortcut: async (body: IUpdateShortcutRequestDTO): Promise<void> => {
    const { id, ...restBody } = body;
    const url = `${baseURL}/${id}`;

    const response = await https.patch<void>(url, restBody);

    const { data } = response;
    return data;
  },

  deleteShortcut: async (id: number): Promise<void> => {
    const url = `${baseURL}/${id}`;

    const response = await https.delete(url);

    const { data } = response;
    return data;
  },

  getShortcutPriceGroups: async (shortcutId?: number): Promise<IShortcutPriceGroupsResponseDTO> => {
    const response = await https.get<IShortcutPriceGroupsResponseDTO>(`${baseURL}/price-groups`, {
      params: { onlyAvailable: true, ...(shortcutId && { shortcutId }) },
    });

    const { data } = response;
    return data;
  },
};
